import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children, requireOnboarded = true }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  if (!ready) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="label-mono text-primary animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  const isOnboardingRoute = location.pathname.startsWith("/onboarding");
  const skipOnboarding = user.role === "super_admin";
  if (requireOnboarded && !user.onboarded && !isOnboardingRoute && !skipOnboarding) {
    return <Navigate to="/onboarding" replace />;
  }
  if (user.onboarded && isOnboardingRoute) {
    return <Navigate to="/app/dashboard" replace />;
  }
  return children;
}
